import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "utils/@reduxjs/toolkit";
import { initialState } from "./initialState";
export const sliceKey = "formsState";

export const formsSlice = createSlice({
      name: sliceKey,
      initialState: initialState,
      reducers: {}
})

export const { reducer, actions } = formsSlice